import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { SCALType } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./view-scal360-purchase-history.component.html'),
    styles:[require('./view-scal360-purchase-history.component.css')],
    selector:'view-scal360-purchase-history'
})
export class ViewScal360PurchaseHistoryComponent{
    dialogTitle='View SCAL 360 Purchase History'
    errorMessage='';
    Scal360PurchaseHistory;
    SelectedCustomerLicenseDetail;
    SCALTypeEnum=SCALType
    scal360LicenseDisplayList;
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        public dialogRef:MdDialogRef<ViewScal360PurchaseHistoryComponent>,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
        private adalService:AdalService,
        private router:Router,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
        this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
        this.getScal360PurchaseHistory()
    }
    getScal360PurchaseHistory(){
        this.isLoading=true;
        this.licenseService.viewScal360PurchaseHistory(this.SelectedCustomerLicenseDetail.LicenseId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.Scal360PurchaseHistory=data.DataObject
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/view-scal360-purchase-history/view-scal360-purchase-history.component.ts